'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePurchaseOrder = undefined;

var _getPurchaseOrderId = require('self-service-api/api/getPurchaseOrderId');

var _getPurchaseOrderId2 = _interopRequireDefault(_getPurchaseOrderId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generatePurchaseOrder = exports.generatePurchaseOrder = function generatePurchaseOrder(termId, currencyCode, itemConfigurations, productBasedOffers) {
  var purchaseConfig = {
    termId: termId,
    currencyCode: currencyCode,
    itemConfigurations: itemConfigurations,
    productBasedOffers: productBasedOffers
  };

  return (0, _getPurchaseOrderId2.default)(purchaseConfig);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/checkout/generatePurchaseOrder.js
// module id = 583
// module chunks = 3 4 5